import axios from "axios";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../../assets/images/japanilogo.png";
import { authOperations } from "../../../state/ducs/auth";
import { cartOperations } from "../../../state/ducs/cart";
import "./index.css";

const Header = ({
  t,
  cartItems,
  removeFromCart,
  handleSectionRef,
  setHomePageSearchedResultProducts,
  setSelectedCategoryId,
  signIn,
  logout,
  removeUser,
  userInfo,
  isAuthenticated,
  clearCart
}) => {
  const [selectedSCat, setSelectedSCat] = useState("");
  const [categories, setCategories] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showCartDropdown, setShowCartDropdown] = useState(false);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/allcategories`)
      .then(function (response) {
        console.log(response.data);
        const respData = response.data;
        respData.reverse();
        setCategories(respData);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const onSearchHandler = () => {
    const params = new URLSearchParams();
    if (searchQuery.trim()) {
      params.append('name', searchQuery.trim());
    }
    if (selectedSCat && selectedSCat !== 'all') {
      params.append('category_id', selectedSCat);
    }

    if (!searchQuery.trim() && (!selectedSCat || selectedSCat === 'all')) {
      return;
    }

    axios
      .get(`${process.env.REACT_APP_API_URL}/search?${params.toString()}`)
      .then((response) => {
        setHomePageSearchedResultProducts(response.data.products || []);
      })
      .catch((error) => {
        console.error("Search error:", error);
        setHomePageSearchedResultProducts([]);
      });
  };

  const navigate = useNavigate();

  const handleSCatChange = (e) => {
    const value = e.target.value;
    setSelectedSCat(value);
    if (setSelectedCategoryId) {
      setSelectedCategoryId(value === 'all' ? null : value);
    }
  };

  let subtotalPrice = 0;
  for (let index = 0; index < cartItems.length; index++) {
    const element = cartItems[index];
    subtotalPrice += parseInt(element.price) * element.quantity;
  }

  const onViewCartHandler = () => {
    navigate("/viewPage");
    setShowCartDropdown(false);
  };

  const onCheckoutHandler = () => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }
    navigate("/checkout");
    setShowCartDropdown(false);
  };

  const handleSearch = () => {
    onSearchHandler();
    handleSectionRef();
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      console.log('Enter key pressed!');
      handleSearch();
    }
  };

  const removeTheItemFromCart = (product) => {
    if (product.cart_id) {
      try {
        axios
          .delete(`${process.env.REACT_APP_API_URL}/cart-items/${product.cart_id}`)
          .then(function (response) {
            console.log(response);
            if (response.status === 200) {
              removeFromCart(product);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    } else {
      removeFromCart(product);
    }
  };

  const styles = {
    headerContainer: {
      backgroundColor: '#ffffff',
      boxShadow: '0 2px 15px rgba(0,0,0,0.1)',
      position: 'sticky',
      top: 0,
      zIndex: 100,
      borderBottom: '3px solid #3498db'
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px 15px'
    },
    headerRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '30px',
      flexWrap: 'wrap'
    },
    logoSection: {
      flex: '0 0 auto'
    },
    logo: {
      display: 'block',
      maxWidth: '180px',
      height: 'auto'
    },
    logoImg: {
      width: '100%',
      height: 'auto',
      maxHeight: '60px',
      objectFit: 'contain'
    },
    searchSection: {
      flex: '1 1 auto',
      maxWidth: '600px',
      display: 'flex',
      backgroundColor: '#f8f9fa',
      borderRadius: '50px',
      overflow: 'hidden',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      border: '2px solid #e9ecef'
    },
    categorySelect: {
      flex: '0 0 auto',
      minWidth: '140px',
      padding: '15px 20px',
      border: 'none',
      backgroundColor: '#3498db',
      color: 'white',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      outline: 'none'
    },
    searchInput: {
      flex: '1 1 auto',
      padding: '15px 20px',
      border: 'none',
      backgroundColor: 'transparent',
      fontSize: '16px',
      outline: 'none',
      color: '#2c3e50'
    },
    searchButton: {
      flex: '0 0 auto',
      padding: '15px 25px',
      backgroundColor: '#e74c3c',
      color: 'white',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '14px',
      fontWeight: '600',
      transition: 'background-color 0.3s ease'
    },
     cartSection: {
       flex: '0 0 auto',
       position: 'relative'
     },
     vendorButtonSection: {
       flex: '0 0 auto',
       marginLeft: '20px',
     },
     vendorButton: {
       padding: '12px 25px',
       backgroundColor: '#9b59b6',
       color: 'white',
       border: 'none',
       borderRadius: '5px',
       cursor: 'pointer',
       fontSize: '14px',
       fontWeight: '600',
       transition: 'background-color 0.3s ease'
     },
    cartWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      padding: '12px 20px',
      backgroundColor: '#2c3e50',
      borderRadius: '12px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      color: 'white'
    },
    cartIcon: {
      position: 'relative',
      fontSize: '24px',
      color: '#3498db'
    },
    cartCounter: {
      position: 'absolute',
      top: '-8px',
      right: '-8px',
      backgroundColor: '#e74c3c',
      color: 'white',
      borderRadius: '50%',
      minWidth: '20px',
      height: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '12px',
      fontWeight: 'bold'
    },
    cartInfo: {
      display: 'flex',
      flexDirection: 'column',
      gap: '2px'
    },
    cartTitle: {
      fontSize: '12px',
      textTransform: 'uppercase',
      color: '#bdc3c7',
      margin: 0,
      fontWeight: '500'
    },
    cartPrice: {
      fontSize: '16px',
      fontWeight: 'bold',
      color: '#3498db',
      margin: 0
    },
    cartDropdown: {
      position: 'absolute',
      top: '100%',
      right: '0',
      width: '400px',
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
      marginTop: '10px',
      zIndex: 1000,
      border: '1px solid #e9ecef',
      maxHeight: '500px',
      overflowY: 'auto'
    },
    cartHeader: {
      padding: '20px',
      borderBottom: '1px solid #e9ecef',
      fontSize: '16px',
      fontWeight: 'bold',
      color: '#2c3e50'
    },
    emptyCart: {
      padding: '40px 20px',
      textAlign: 'center',
      color: '#7f8c8d',
      fontSize: '14px'
    },
    cartItem: {
      display: 'flex',
      alignItems: 'center',
      padding: '15px 20px',
      borderBottom: '1px solid #f8f9fa',
      gap: '15px'
    },
    cartItemImg: {
      width: '50px',
      height: '50px',
      objectFit: 'cover',
      borderRadius: '6px',
      border: '1px solid #e9ecef'
    },
    cartItemInfo: {
      flex: '1 1 auto',
      display: 'flex',
      flexDirection: 'column',
      gap: '4px'
    },
    cartItemName: {
      fontSize: '14px',
      color: '#2c3e50',
      fontWeight: '500',
      margin: 0
    },
    cartItemDetails: {
      fontSize: '12px',
      color: '#7f8c8d'
    },
    cartItemPrice: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#e74c3c'
    },
    removeBtn: {
      width: '30px',
      height: '30px',
      borderRadius: '50%',
      border: 'none',
      backgroundColor: '#e74c3c',
      color: 'white',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '12px',
      transition: 'background-color 0.3s ease'
    },
    cartActions: {
      padding: '20px',
      display: 'flex',
      gap: '10px'
    },
    actionBtn: {
      flex: 1,
      padding: '12px 20px',
      borderRadius: '8px',
      border: 'none',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '600',
      transition: 'all 0.3s ease'
    },
    viewCartBtn: {
      backgroundColor: '#3498db',
      color: 'white'
    },
    checkoutBtn: {
      backgroundColor: '#2ecc71',
      color: 'white'
    },
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.1)',
      zIndex: 999
    }
  };

  return (
    <div style={styles.headerContainer}>
      <div style={styles.container}>
         <div style={styles.headerRow}>
           {/* Logo Section */}
           <div style={styles.logoSection}>
             <Link to="/" 
             className="logo-style"
             // style={styles.logo}
             >
               <img src={Logo} alt="Logo" style={styles.logoImg} />
             </Link>
           </div>

           {/* Vendor Registration Button */}
           <div style={styles.vendorButtonSection}>
             <Link to="/register?vendor=true">
               <button
                 style={styles.vendorButton}
                 onMouseEnter={(e) => e.target.style.backgroundColor = '#8e44ad'}
                 onMouseLeave={(e) => e.target.style.backgroundColor = '#9b59b6'}
               >
                 Register as Vendor
               </button>
             </Link>
           </div>

           {/* Search Section */}
          <div className="search-section-container" 
          // style={styles.searchSection}
          >
            <select
              onChange={handleSCatChange}
              style={styles.categorySelect}
              value={selectedSCat}
            >
              <option value="all">{t("catAll")}</option>
              {categories.length &&
                categories.map((item) => (
                  <option key={item.id} value={item.id}>{item.name}</option>
                ))}
            </select>
            
            <input
              type="text"
              placeholder={t("searchKeyWord")}
              style={styles.searchInput}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={handleKeyPress}
            />
            
            <button
              style={styles.searchButton}
              onClick={handleSearch}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#c0392b'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#e74c3c'}
            >
              <i className="fa fa-search"></i>
              {t("search")}
            </button>
          </div>

          {/* Cart Section */}
          <div style={styles.cartSection}>
            <div
              style={styles.cartWrapper}
              onClick={() => setShowCartDropdown(!showCartDropdown)}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#34495e'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#2c3e50'}
            >
              <div style={styles.cartIcon}>
                <i className="fa fa-shopping-cart"></i>
                {cartItems.length > 0 && (
                  <span style={styles.cartCounter}>{cartItems.length}</span>
                )}
              </div>
              
              <div style={styles.cartInfo}>
                <h6 style={styles.cartTitle}>{t("shoppingCart")}</h6>
                <h6 style={styles.cartPrice}>৳{subtotalPrice || "0.00"}</h6>
              </div>
            </div>

            {/* Cart Dropdown */}
            {showCartDropdown && (
              <>
                <div style={styles.cartDropdown}>
                  <div style={styles.cartHeader}>
                    Shopping Cart ({cartItems.length} items)
                  </div>
                  
                  {!cartItems.length ? (
                    <div style={styles.emptyCart}>
                      <i className="fa fa-shopping-cart" style={{fontSize: '48px', color: '#ddd', marginBottom: '15px'}}></i>
                      <p>Your shopping cart is empty</p>
                    </div>
                  ) : (
                    <>
                      {cartItems.map((product, index) => (
                        <div key={index} style={styles.cartItem}>
                          <img
                            src={`${process.env.REACT_APP_PRODUCT_IMAGE_URL}/${product.photo}`}
                            alt={product.name}
                            style={styles.cartItemImg}
                          />
                          
                          <div style={styles.cartItemInfo}>
                            <p style={styles.cartItemName}>
                              {product.name.length > 25 ? product.name.substr(0, 25) + '...' : product.name}
                            </p>
                            <div style={styles.cartItemDetails}>
                              Qty: {product.quantity} × ৳{product.price}
                            </div>
                            <div style={styles.cartItemPrice}>
                              ৳{product.price * product.quantity}
                            </div>
                          </div>
                          
                          <button
                            style={styles.removeBtn}
                            onClick={() => removeTheItemFromCart(product)}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#c0392b'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = '#e74c3c'}
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        </div>
                      ))}
                      
                      <div style={styles.cartActions}>
                        <button
                          style={{...styles.actionBtn, ...styles.viewCartBtn}}
                          onClick={onViewCartHandler}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#2980b9'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = '#3498db'}
                        >
                          View Cart
                        </button>
                        <button
                          style={{...styles.actionBtn, ...styles.checkoutBtn}}
                          onClick={onCheckoutHandler}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#27ae60'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = '#2ecc71'}
                        >
                          Checkout
                        </button>
                      </div>
                    </>
                  )}
                </div>
                
                <div
                  style={styles.overlay}
                  onClick={() => setShowCartDropdown(false)}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    cartItems: state.cart,
    isAuthenticated: state.auth.token !== null,
    userInfo: state.auth.user,
  };
};

const mapDispatchToProps = {
  removeFromCart: cartOperations.removeFromCart,
  logout: authOperations.logout,
  removeUser: authOperations.removeAuthUser,
  clearCart: cartOperations.clearCart,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);